<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2022-03-02 17:25:56
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\components\top.vue
-->
<template>
    <div class="personal_header">
        <div class="personal_content">
            <div class="personal_div">
                <img @click="toIndex" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/logo/perLogo.png" alt="">
                <div class="personal_center">
                    <div class="personal_center_index" @click="toPersonalIndex('index')" :style="{color:(customer.fromPage == 'personalIndex' ? '#E1251B ' : '')}">我的首页</div>
                    <div class="dropdown_red personal_center_msg">
                        <el-dropdown>
                            <span class="el-dropdown-link" style="font-size:16px;color:#333333 ">
                                <span class="strokeDiv">账户管理</span>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click.native="toPersonalIndex('account')">账户信息</el-dropdown-item>
                                    <el-dropdown-item @click.native="toPersonalIndex('address')">收货地址</el-dropdown-item>
                                    <el-dropdown-item @click.native="toPersonalIndex('enterprise')">企业信息</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </div>
                <simple-cart leftValue="394"/>
            </div>
        </div>
    </div>
</template>
<script>
import SimpleCart from '../cart/SimpleCart.vue';
export default {
  components:{SimpleCart},
  data() {
    return {
        activeIndex: '1',
        activeIndex2: '1'
    };
  },
  props: {
    customer: {
        type: Object,
        default: {}
    }
  },
  methods: {
    toCart(){
        this.$router.push({path:'/cart/cartList',query:{}});
    },
    toPersonalIndex(type){
        if(type == 'index'){
            this.$router.push({path:'/personal',query:{}});
        }else if(type == 'account'){
            this.$router.push({path:'/personal/accountInfo',query:{}});
        }else if(type == 'address'){
            this.$router.push({path:'/personal/receivingAddress',query:{}});
        }else if(type == 'enterprise'){
            this.$router.push({path:'/personal/enterprise',query:{}});
        }
        
    },
    toIndex(){
        this.$router.push({path: '/'})
    }
  }
};
</script>
<style scoped>
/* 个人中心-头部 */
.personal_content{
    width: 100%;
    height: 112px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #eeeeee;
    box-shadow: 0px 7px 7px -7px #eeeeee;
}
.personal_div{
    width: 1200px;
    height: 112px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.personal_div>img{
    width: 173px;
    margin-left: 32px;
    cursor: pointer;
}
/* 中间 */
.personal_center{
    width: 462px;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}
.personal_center_index{
    cursor: pointer;
}
.personal_center_msg{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/personal/perHeader.vue